/* eslint-disable */

import {gsap} from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

let activeScrolls = 0;

const anchorScroll = {
  init: function () {
    const links = document.querySelectorAll('a[href*="#"]:not([href="#"])');
    const selects = document.querySelectorAll('[data-anchor-bar-select-js]');

    const scrollToTarget = (target) => {
      if (!target) return;

      const topOffset = 100;

      gsap.to(window, {
        duration: 0.6,
        scrollTo: { y: target, offsetY: topOffset },
        ease: 'power2.out',
        onStart: () => {
          activeScrolls++;
          window.__programmaticScroll = true;
        },
        onComplete: () => {
          activeScrolls--;
          if (activeScrolls <= 0) window.__programmaticScroll = false;
        },
        onInterrupt: () => {
          activeScrolls--;
          if (activeScrolls <= 0) window.__programmaticScroll = false;
        }
      });
    };

    links.forEach(link => {
      link.addEventListener('click', function (e) {
        console.log('test click')
        const href = link.getAttribute('href') || link.getAttribute('value');
        const hash = href.includes('#') ? '#' + href.split('#')[1] : href;
        const target = document.querySelector(hash);

        if (target) {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('anchor:clicked'));
          scrollToTarget(target);
        }
      });
    });

    selects.forEach(select => {
      select.addEventListener('change', function (e) {
        const href = select.value;
        const hash = href.includes('#') ? '#' + href.split('#')[1] : href;
        const target = document.querySelector(hash);

        if (target) {
          e.preventDefault();
          scrollToTarget(target);
        }
      });
    });
  },
};

export default anchorScroll;
